// Pricing migration 17 (ADO-2248 DEC-6): the one place the real-prices build flag
// is read.
//
// Off (the default, and every deployed environment but dev today): no price request is
// made, and the product surfaces keep the stand-in unit price (`provisionalPrice.ts`)
// and the sample RRP (`productCardSample.ts`). On: the unit price and the RRP come
// from row 16's endpoint (`price-quotes.client.ts`).
//
// Vite bakes `VITE_*` values in at build time. Locally the value is `apps/web/.env`'s; a
// deployed web build takes it per environment from the committed map
// `tools/deploy/real-prices.mjs` (passed by `tools/deploy/build-push-images.sh`; dev on, stg
// off), and the e2e build does not set it. The flag, the map, the stand-in and
// the sample RRP are deleted once stg is on and has proven to work, without waiting for prod;
// the basket's stand-in goes with row 8's PRICING_REFERENCE_DATA_ENABLED setting (the story's
// Task 11).

/** True only when `VITE_REAL_PRICES_ENABLED` is exactly `'true'`. Read on every
 *  call, not once at import, so a spec can stub it per test. */
export function realPricesEnabled(): boolean {
  return import.meta.env.VITE_REAL_PRICES_ENABLED === 'true';
}
